import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// module configurations
export const LISTING_COLUMNS = [
  {
    id: 'posterUrl',
    label: 'Image Preview',
    width: '10%',
    align: 'left',
    dataKey: 'posterUrl',
    sortable: false,
    type: CELL_DATA_TYPES.IMAGE,
  },
  {
    id: 'title',
    label: 'Title',
    width: '30%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'gatheringStartDate',
    label: 'Gathering Start Date',
    width: '15%',
    align: 'right',
    dataKey: 'gatheringStartDate',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'gatheringDuration',
    label: 'Gathering Duration',
    width: '15%',
    align: 'right',
    dataKey: 'gatheringDuration',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.TRANSLATE.value,
    label: ACTIONS.TRANSLATE.label,
  },
  {
    action: ACTIONS.UPLOAD_POSTER.value,
    label: ACTIONS.UPLOAD_POSTER.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.VIEW_DATA_CHANGE_LOGS.value,
    label: ACTIONS.VIEW_DATA_CHANGE_LOGS.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_COMMUNITY_GATHERING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'posterUrl',
    label: 'Horizontal Poster URL',
    dataKey: 'posterUrl',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'squarePosterUrl',
    label: 'Vertical Poster URL',
    dataKey: 'squarePosterUrl',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'findMoreBtnText',
    label: 'Find more button text',
    dataKey: 'findMoreBtnText',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'findMoreBtnUrl',
    label: 'Find more button URL',
    dataKey: 'findMoreBtnUrl',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bookTicketBtnText',
    label: 'Ticket button text',
    dataKey: 'bookTicketBtnText',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bookTicketBtnUrl',
    label: 'Ticket button URL',
    dataKey: 'bookTicketBtnUrl',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'gatheringStartDate',
    label: 'Gathering Start Date',
    dataKey: 'gatheringStartDate',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'gatheringDuration',
    label: 'Gathering Duration (in minutes)',
    dataKey: 'gatheringDuration',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
